import { action } from "typesafe-actions";
import { ICampaignReport } from "./CampaignReports.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  showMessage,
} from "../../messages/messagesActions";
import { endPoints } from "../../../constants/endPoints";
import { ISearchQueryParams } from "../../common/common.types";
import { addSearchFilterToAdvanceFilter } from "../../common/helpers";

/* =========================================================
   LIST ACTIONS
========================================================= */
export const FETCH_CAMPAIGN_REPORTS_LIST_PROGRESS = "FETCH_CAMPAIGN_REPORTS_LIST_PROGRESS";
export const FETCH_CAMPAIGN_REPORTS_LIST_SUCCESS = "FETCH_CAMPAIGN_REPORTS_LIST_SUCCESS";
export const FETCH_CAMPAIGN_REPORTS_LIST_FAILURE = "FETCH_CAMPAIGN_REPORTS_LIST_FAILURE";

export const fetchCampaignReportsListProgress = () => action(FETCH_CAMPAIGN_REPORTS_LIST_PROGRESS);
export const fetchCampaignReportsListSuccess = (list: ICampaignReport[], totalRecords: number) =>
  action(FETCH_CAMPAIGN_REPORTS_LIST_SUCCESS, { list, totalRecords });
export const fetchCampaignReportsListFailure = () => action(FETCH_CAMPAIGN_REPORTS_LIST_FAILURE);

export const fetchCampaignReportsListAsync = (queryParams: ISearchQueryParams): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      dispatch(fetchCampaignReportsListProgress());

      const {
        page, rowsPerPage, status,
        campaign_uuid,
        year,
        status_filter,
        package_id,
        assign_to_uuid,
        manager_uuid,
        source,
        pin_code,
        advancedFilters,
        date
      } = queryParams as any;

      const advanceFilter: any[] = Array.isArray(advancedFilters) ? [...advancedFilters] : [];

      addSearchFilterToAdvanceFilter(advanceFilter, ["source"], source);
      addSearchFilterToAdvanceFilter(advanceFilter, ["pin_code"], pin_code);

      let finalUrl = `${endPoints.crossroadsLeads.getCampaignReports}?pageNo=${page}&itemPerPage=${rowsPerPage}`;

      if (date && date.fromDate && date.toDate) {
        finalUrl += `&from_date=${date.fromDate}&to_date=${date.toDate}`;
      }

      if (date && date.rangeType) {
        finalUrl += `&rangeType=${date.rangeType}`;
      }

      if (status && status !== "-1") {
        finalUrl += `&status=${status}`;
      }

      // Send campaign_uuid as direct query parameter instead of advanceFilter
      if (campaign_uuid && campaign_uuid !== "") {
        finalUrl += `&campaign_uuid=${campaign_uuid}`;
      }

      // Send year as direct query parameter instead of advanceFilter
      if (year && year !== "") {
        finalUrl += `&year=${year}`;
      }

      // Send status_filter as direct query parameter
      if (status_filter && status_filter !== "") {
        finalUrl += `&status_filter=${status_filter}`;
      }

      // Send package_id as direct query parameter
      if (package_id) {
        finalUrl += `&package_id=${package_id}`;
      }

      // Send assign_to_uuid as direct query parameter
      if (assign_to_uuid && assign_to_uuid !== "") {
        finalUrl += `&assign_to_uuid=${assign_to_uuid}`;
      }

      // Send manager_uuid as direct query parameter
      if (manager_uuid && manager_uuid !== "") {
        finalUrl += `&manager_uuid=${manager_uuid}`;
      }

      if (advanceFilter.length > 0) {
        finalUrl += `&advanceFilter=${JSON.stringify(advanceFilter)}`;
      }

      const res = await api.get(finalUrl);
      const data = res.data?.data || [];
      const totalRecords = res.data?.totalRecords || 0;

      dispatch(fetchCampaignReportsListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchCampaignReportsListFailure());
      dispatch(showMessage({
        message: err?.response?.data?.message || "Failed to fetch campaign reports",
        type: "error",
        displayAs: "snackbar",
      }));
    }
  };

/* =========================================================
   CLEAR STATE ACTIONS
========================================================= */
export const CLEAR_CAMPAIGN_REPORTS_STATE = "CLEAR_CAMPAIGN_REPORTS_STATE";

export const clearCampaignReportsState = () => action(CLEAR_CAMPAIGN_REPORTS_STATE);
